import React from 'react'
import Faqs from "./Components";

export const FaqsView = () => {
  const faqs = [
    {
      question: 'Is MeetOcto suitable for teams/Organizations?',
      answer: 'Yes! MeetOcto works for both individuals and teams. You can auto-assign meetings, see team availability, and keep everyone on the same page.'
    },
    {
      question: 'Can I customize my booking page?',
      answer: 'Absolutely! You can add your photo, set your available hours, and even include a short welcome message to make it feel personal.'
    },
    {
      question: 'How do I connect my calendar to MeetOcto?',
      answer: 'Simply link your Google or Outlook calendar, and MeetOcto will automatically sync your availability—no extra steps needed!'
    },
    {
      question: 'Does MeetOcto send reminders to attendees?',
      answer: 'Yep! Automated email reminders go out so no one forgets a meeting, helping reduce no-shows.'
    },
  ]
  return (
    <div className="faqs wrapper">
      <h1 className="heading pb-3">FAQ’s</h1>
      {faqs.map((faq, index) => (
        <Faqs key={index} faqs={faq} active={index === 1} />
      ))}
    </div>
  )
}
